import React from 'react';
import Grid from '@mui/material/Grid';
import FormInputText from '../../../../../common/Forms/FormTextField';
import { useDispatch } from 'react-redux';
import {
  setContractAgency,
  setReviewDate,
  setClearDate,
} from '../../../../../../redux/organization/organizationTabs/organizationCompliance/organizationComplianceSlice';

const ComplianceForm = (props) => {
  const { control, defaultValue, register, errors } = props;
  const dispatch = useDispatch();

  return (
    <>
      <Grid container spacing={2} style={{ marginTop: '0px' }}>
        <Grid item xs={12} sm={4}>
          <FormInputText
            name='contractAgency'
            type='text'
            control={control}
            errors={!!errors.contractAgency}
            helperText={errors?.contractAgency?.message}
            label='Contract Agency'
            register={register('contractAgency', {
              onChange: (e) => dispatch(setContractAgency(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormInputText
            name='reviewDate'
            type='date'
            control={control}
            shrink={true}
            label='Review Date'
            register={register('reviewDate', {
              onChange: (e) => dispatch(setReviewDate(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormInputText
            name='clearDate'
            type='date'
            control={control}
            shrink={true}
            label='Clear Date'
            register={register('clearDate', {
              onChange: (e) => dispatch(setClearDate(e.target.value)),
            })}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ComplianceForm;
